import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { Sticky } from '@bd/bdcore-utilities';

import PageSubMenu from '../../components/PageSubMenu';
import { colors } from '../../styles';

const styles = css`
  @media (min-width: 992px) {
    background-color: transparent;
    padding: 0;
    ul {
      text-align: center;
      li a {
        color: #8A8A8A;
        text-transform: none;
        font-size: 16px;
        &.active {
          color: ${colors.brand1};
        }
      }
    }
  }
`;

const menu = css`
  width: 100%;
  height: auto;
  transition: all .3s ease-out;
  @media(min-width: 992px) {
    top: 0 !important;
    padding: 0;
    height: 70px;
    position: relative !important;
  }
  @supports(position: sticky) {
    top: 70px !important;
    z-index: 11 !important;
    position: sticky !important;
    @media(min-width: 992px) {
      top: 150px !important;
    }
  }

  .page-menu {
    background-color: rgba(235, 235, 235, 0.95);
    padding: 0;
    top: 57px !important;
    @media(min-width: 992px) {
      background-color: rgba(255, 255, 255, 0.95);
      top: auto !important;
    }

    li {
      margin: 10px;

      a {
        background-color: transparent !important;
      }
    }
  }
`;

const MenuVideoCategories = ({ page }) => {
  const categoryLinks = get(page, 'video_section', []).map(g => ({
    name: 'video-gallery-filtered',
    params: { gallery: get(g, 'category') },
    title: get(g, 'category'),
  }));
  return (
    <Sticky className={menu}>
      <PageSubMenu
        className={styles}
        title="Gallery Menu"
        items={[
          {
            name: 'video-gallery',
            title: 'All Videos',
          },
        ].concat(categoryLinks)}
      />
    </Sticky>
  );
};

MenuVideoCategories.propTypes = {
  page: PropTypes.object.isRequired,
};

export default MenuVideoCategories;



// WEBPACK FOOTER //
// ./src/pages/VideoGallery/MenuVideoCategories.js